export default __webpack_public_path__ + "static/media/84-min.491c1e35.jpg";